const config = {
  version: "20250428.2",
  apiurl: "/data.json",
  successtimeout: 36000,
  gtmAnalyticsId: "GTM-PJ5XJHH",
  analyticsId: "UA-132321687-1"
};
// GTM-PJ5XJHH
export default config;
